/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioSharepointIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-sharepoint-prod" */ './utils').then(
			(m) => m.ForgePioSharepointIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/icon' },
);

const LazyForgePioSharepointSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-sharepoint-prod-search-result" */ './utils').then(
			(m) => m.ForgePioSharepointSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioSharepointIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioSharepointIconComponent />
	</Suspense>
);

export const ForgePioSharepointSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioSharepointSearchResultIconComponent />
	</Suspense>
);
